import { DatapointvaluesDPIDValueItem } from 'api';
import { buildBodyFromInterview } from 'api/hooks/useDataPointValues';
import pick from 'lodash/pick';

import { buildBodyFromVirtualBooleans } from 'containers/Underwriting/utils';

import { HAZARDOUS_ACTIVITIES_URNS } from '../constants';
import schema from '../schema';
import { FormValues } from '../types';

const formatSubmitPayload = (values: Partial<FormValues>): DatapointvaluesDPIDValueItem[] => {
  const booleanDPIDBody = buildBodyFromVirtualBooleans(
    values['urn:pg:data-point:virtual-insured-hazardous-activities-list'],
    HAZARDOUS_ACTIVITIES_URNS
  );

  const nonBooleanDPIDBody = buildBodyFromInterview(
    pick(values, 'urn:pg:data-point:insured-risk-activity-description'),
    schema
  );

  return [...booleanDPIDBody, ...nonBooleanDPIDBody];
};

export default formatSubmitPayload;
